import { ANALYTICS_IMAGE_SCROLLED } from "./constants";
import { createAction } from "redux-actions";

export const analyticsScrollImage = createAction(ANALYTICS_IMAGE_SCROLLED);
